import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';

function TrainingFilters({ filters, setFilters }) {
    return (
        <div className="training-filters-wrapper mb-4">
            <Row className="g-3">
                <Col md={4}>
                    <Form.Control
                        type="text"
                        placeholder="Search challenges..."
                        value={filters.search}
                        onChange={(e) => setFilters({ ...filters, search: e.target.value })}
                        className="training-search-input"
                    />
                </Col>
                <Col md={4}>
                    <Form.Select
                        value={filters.category}
                        onChange={(e) => setFilters({ ...filters, category: e.target.value })}
                        className="training-category-filter"
                    >
                        <option value="All">All Categories</option>
                        <option value="OSINT">OSINT</option>
                        <option value="Pwn">Pwn</option>
                        <option value="Web">Web</option>
                        <option value="Reverse Engineering">Reverse Engineering</option>
                        <option value="Crypto">Crypto</option>
                        <option value="Forensics">Forensics</option>
                        <option value="Misc">Misc</option>
                        <option value="Steganography">Steganography</option>
                        <option value="Binary Exploitation">Binary Exploitation</option>
                        <option value="Networking">Networking</option>
                        <option value="Programming">Programming</option>
                        <option value="Game Hacking">Game Hacking</option>
                        <option value="Full Pwn">Full Pwn</option>
                    </Form.Select>
                </Col>
                <Col md={4}>
                    <Form.Select
                        value={filters.difficulty}
                        onChange={(e) => setFilters({ ...filters, difficulty: e.target.value })}
                        className="training-difficulty-filter"
                    >
                        <option value="All">All Difficulties</option>
                        <option value="Easy">Easy</option>
                        <option value="Medium">Medium</option>
                        <option value="Hard">Hard</option>
                        <option value="Extreme">Extreme</option>
                    </Form.Select>
                </Col>
            </Row>
        </div>
    );
}

export default TrainingFilters;
